var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { i18n, utils as dataUtils } from '@easydata/core';
import { domel } from '@easydata/ui';
import { browserUtils } from '../utils/browser_utils';
var ResultFacet = /** @class */ (function () {
    function ResultFacet(container, options) {
        var _this = this;
        this.container = container;
        this.title = i18n.getText('Facets', 'DefaultFacetTitle');
        this.cssPrefix = 'eqjs-facet';
        this.dialogTitle = i18n.getText('Facets', 'DefaultDlgTitle');
        this.options = {};
        this.canDisplayFlag = true;
        this.downloadAllClickHandler = function () {
            var resultTable = _this.getContext().resultTable;
            if (!resultTable.elasticChunks) {
                var nextChunkStart_1 = resultTable.getCachedRows().length;
                var recordsToLoad_1 = resultTable.getTotal() - resultTable.getCachedCount();
                var ds = _this.getDialogService();
                var dlg_1 = ds.openProgress({
                    title: i18n.getText('Facets', 'LoadDataDlgTitle'),
                    content: i18n.getText('Facets', 'LoadDataDlgContent')
                        .replace('{loadedRecs}', '0')
                        .replace('{totalRecs}', "" + recordsToLoad_1),
                    onSubmit: function () { return _this.refresh(); },
                    determinated: true
                });
                var loadedRecords_1 = 0;
                setTimeout(function () {
                    resultTable.getRows({ offset: nextChunkStart_1, limit: recordsToLoad_1 })
                        .then(function (_) {
                        loadedRecords_1 += _.length;
                        var progress = loadedRecords_1 / recordsToLoad_1;
                        dlg_1.updateContent(i18n.getText('Facets', 'LoadDataDlgContent')
                            .replace('{loadedRecs}', "" + loadedRecords_1)
                            .replace('{totalRecs}', "" + recordsToLoad_1));
                        dlg_1.updateProgress(progress);
                    })
                        .catch(function (error) {
                        dlg_1.submit();
                        _this.getContext().throwError(error);
                    });
                }, 10);
            }
            else {
                var ds = _this.getDialogService();
                var dlg_2 = ds.openProgress({
                    title: i18n.getText('Facets', 'LoadDataDlgTitle'),
                    onSubmit: function () { return _this.refresh(); },
                    determinated: false
                });
                _this.loadElasticChunk()
                    .then(function (_) {
                    dlg_2.submit();
                })
                    .catch(function (error) {
                    dlg_2.submit();
                    _this.getContext().throwError(error);
                });
            }
        };
        dataUtils.assignDeep(this.options, options);
    }
    ResultFacet.prototype.init = function (slot) {
        this.slot = slot;
        this.contentDiv = domel('div', this.slot)
            .addClass(this.cssPrefix + "-content")
            .toDOM();
        this.displayMessageDiv = domel('div', this.slot).hide().toDOM();
    };
    ResultFacet.prototype.showSettingsDialog = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var ds = _this.getDialogService();
            var content = _this.renderDialogContent();
            var dlg = ds.open({
                title: _this.dialogTitle,
                body: content,
                cancelable: true,
                closable: false,
                onSubmit: function () {
                    var submited = _this.submitSettingsDialog();
                    if (submited) {
                        resolve(true);
                    }
                    return submited;
                },
                onCancel: function () {
                    resolve(false);
                }
            });
            _this.afterDialogOpened(dlg);
        });
    };
    ResultFacet.prototype.afterDialogOpened = function (dlg) {
    };
    ResultFacet.prototype.renderDialogContent = function () {
        var fieldsContainer;
        var b = domel('div')
            .addClass('kfrm-form')
            .addChild('div', function (b) { return fieldsContainer = b
            .addClass("" + (browserUtils.isIE()
            ? 'kfrm-fields-ie col-ie-1-4 label-align-right'
            : 'kfrm-fields col-a-1 label-align-right'))
            .toDOM(); });
        this.renderFormFields(b.toDOM(), fieldsContainer);
        return b.toDOM();
    };
    ResultFacet.prototype.renderFormFields = function (form, fieldsContainer) {
        var _this = this;
        var cont = fieldsContainer;
        if (browserUtils.isIE()) {
            cont = domel('div', fieldsContainer)
                .addClass('kfrm-field-ie')
                .toDOM();
        }
        domel(cont)
            .addChild('label', function (b) { return b
            .attr('for', 'tab_name')
            .addText(i18n.getText('Facets', 'TabNameLabel')); })
            .addChild('input', function (b) { return b
            .id('facetTabName')
            .name('tab_name')
            .type('text')
            .attr('value', _this.title); });
    };
    ResultFacet.prototype.submitSettingsDialog = function () {
        var tabNameInput = document.querySelector('#facetTabName');
        if (tabNameInput.value.length == 0)
            return false;
        this.title = tabNameInput.value;
        return true;
    };
    ResultFacet.prototype.getDialogService = function () {
        return this.getContext()
            .getServices()
            .getDialogService();
    };
    ResultFacet.prototype.canDisplay = function () {
        var context = this.getContext();
        var resultTable = context.resultTable;
        return (resultTable.getCachedCount() == resultTable.getTotal());
    };
    ResultFacet.prototype.showErrorMessage = function (message) {
        this.displayMessageDiv.innerHTML = message;
        this.displayMessageDiv.classList.add(this.cssPrefix + "-error-message");
        domel(this.displayMessageDiv).show();
    };
    ResultFacet.prototype.showUnableDisplayMessage = function (message) {
        var context = this.getContext();
        var resultTable = context.resultTable;
        this.displayMessageDiv.innerHTML = message || i18n.getText('Facets', 'ErrNotEnoughData')
            .replace('{totalRecs}', "" + resultTable.getTotal())
            .replace('{cachedRecs}', "" + resultTable.getCachedCount())
            .replace(/\[(.*)\]/g, "<a href='javascript:void(0)' class=\"" + this.cssPrefix + "-download-all-link\">$1</a>");
        var link = this.displayMessageDiv.querySelector("a." + this.cssPrefix + "-download-all-link");
        if (link) {
            link.addEventListener('click', this.downloadAllClickHandler);
        }
        domel(this.contentDiv).hide();
        domel(this.displayMessageDiv).show();
    };
    ResultFacet.prototype.hideUnableDisplayMessage = function () {
        domel(this.displayMessageDiv).hide();
        domel(this.contentDiv).show();
    };
    ResultFacet.prototype.getContext = function () {
        return this.container.getContext();
    };
    ResultFacet.prototype.getQuery = function () {
        return this.getContext().getQuery();
    };
    ResultFacet.prototype.saveToData = function () {
        return { title: this.title, type: this.getType() };
    };
    ResultFacet.prototype.loadFromData = function (data) {
        if (data) {
            this.title = data.title;
        }
    };
    ResultFacet.prototype.refresh = function () {
        this.hideUnableDisplayMessage();
        if (this.canDisplay()) {
            this.refreshCore();
        }
        else {
            this.showUnableDisplayMessage();
        }
    };
    ResultFacet.prototype.loadElasticChunk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resultTable, nextChunkStart;
            var _this = this;
            return __generator(this, function (_a) {
                resultTable = this.getContext().resultTable;
                nextChunkStart = resultTable.getCachedRows().length;
                //next chunk
                return [2 /*return*/, resultTable.getRows({ offset: nextChunkStart, limit: resultTable.chunkSize })
                        .then(function (_) {
                        return resultTable.totalIsKnown()
                            ? Promise.resolve()
                            : _this.loadElasticChunk();
                    })];
            });
        });
    };
    ResultFacet.prototype.onResize = function () {
    };
    return ResultFacet;
}());
export { ResultFacet };
//# sourceMappingURL=result_facet.js.map